import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {
  IoCheckmarkCircle, IoWarning, IoCloseCircle, IoInformationCircle, IoClose,
} from 'react-icons/io5';
import '../assets/style/subscribeStatusModal.scss';

Modal.setAppElement('#root');

const ICONS_BY_TYPE = {
  success: IoCheckmarkCircle,
  warn: IoWarning,
  error: IoCloseCircle,
  info: IoInformationCircle,
};

const SubscribeStatusModal = ({
  isOpen, closeModal, type, message,
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const Icon = ICONS_BY_TYPE[type] || ICONS_BY_TYPE.info;

  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);

  const closeAnimatedModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      closeModal();
    }, 300);
  };

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Subscription status"
      overlayClassName={`subscribeStatusModal-overlay ${isClosing ? 'closing' : ''}`}
      className="subscribeStatusModal"
      onRequestClose={closeAnimatedModal}
      shouldCloseOnOverlayClick={false}
    >
      <div className={`subscribeStatusModal-content subscribeStatusModal-content--${type}`}>
        <Icon className="subscribeStatusModal-icon" />
        <p className="subscribeStatusModal-message">{message}</p>
        <button aria-label="Close" title="Close" className="subscribeStatusModal-close" type="button" onClick={closeAnimatedModal}>
          <IoClose />
        </button>
      </div>
    </Modal>
  );
};

SubscribeStatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['success', 'warn', 'error', 'info']).isRequired,
  message: PropTypes.string.isRequired,
};

export default SubscribeStatusModal;
